// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 21,
  argument: "",
  verses: [
    { n: 1, text: "As the divisions of waters, so the heart of the king is in the hand of the Lord: whithersoever he will, he shall turn it." },
    { n: 2, text: "Every way of a man seemeth right to himself: but the Lord weigheth the hearts." },
    { n: 3, text: "To do mercy and judgment, pleaseth the Lord more than victims." },
    { n: 4, text: "Haughtiness of the eyes is the enlarging of the heart: the lamp of the wicked is sin." },
    { n: 5, text: "The thoughts of the industrious always bring forth abundance: but every sluggard is always in want." },
    { n: 6, text: "He that gathereth treasures by a lying tongue, is vain and foolish, and shall stumble upon the snares of death." },
    { n: 7, text: "The robberies of the wicked shall be their downfall, because they would not do judgment." },
    { n: 8, text: "The perverse way of a man is strange: but as for him that is pure, his work is right." },
    { n: 9, text: "It is better to sit in a corner of the house-top, than with a brawling woman, and in a common house." },
    { n: 10, text: "The soul of the wicked desireth evil, he will not have pity on his neighbour." },
    { n: 11, text: "When a pestilent man is punished, the little one will be wiser: and if he follow the wise, he will receive knowledge." },
    { n: 12, text: "The just considereth seriously the house of the wicked, that he may withdraw the wicked from evil." },
    { n: 13, text: "He that stoppeth his ear against the cry of the poor, shall also cry himself, and shall not be heard." },
    { n: 14, text: "A secret present quencheth anger: and a gift in the bosom, the greatest wrath." },
    { n: 15, text: "It is joy to the just to do judgment: and dread to them that work iniquity." },
    { n: 16, text: "A man that shall wander out of the way of doctrine, shall abide in the company of the giants." },
    { n: 17, text: "He that loveth good cheer, shall be in want: he that loveth wine, and fat things, shall not be rich." },
    { n: 18, text: "The wicked is delivered up for the just: and the unjust for the righteous." },
    { n: 19, text: "It is better to dwell in a wilderness, than with a quarrelsome and passionate woman." },
    { n: 20, text: "There is a treasure to be desired, and oil in the dwelling of the just: and the foolish man shall spend it." },
    { n: 21, text: "He that followeth justice and mercy, shall find life, justice, and glory." },
    { n: 22, text: "The wise man hath scaled the city of the strong, and hath cast down the strength of the confidence thereof." },
    { n: 23, text: "He that keepeth his mouth and his tongue, keepeth his soul from distress." },
    { n: 24, text: "The proud and the arrogant is called ignorant, who in anger worketh pride." },
    { n: 25, text: "Desires kill the slothful: for his hands have refused to work at all." },
    { n: 26, text: "He longeth and desireth all the day: but he that is just, will give, and will not cease." },
    { n: 27, text: "The sacrifices of the wicked are abominable, because they are offered of wickedness." },
    { n: 28, text: "A lying witness shall perish: an obedient man shall speak of victory." },
    { n: 29, text: "The wicked man impudently hardeneth his face: but he that is righteous, correcteth his way." },
    { n: 30, text: "There is no wisdom, there is no prudence, there is no counsel against the Lord." },
    { n: 31, text: "The horse is prepared for the day of battle: but the Lord giveth safety." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "It. Though it be free, and may resist grace or embrace virtue, Isaias xlv. 22., Jeremias iii. 14., and vii. 3., and Josue xxiv. 23. (Calmet) — Yet God knows how to turn the heart even of a king, so as to preserve his liberty, with the same ease as a gardener brings the streams of water to his plants.", attribution: "Menochius" }
    ] },
    { verse: 3, notes: [
      { text: "Mercy. Septuagint, \"justice and truth.\" (Haydock) See Osee vi. 6.", attribution: "Menochius" }
    ] },
    { verse: 4, notes: [
      { text: "Heart. Or when it is proud, it causes the eyes to appear so too. (Calmet) — Lamp. Protestants, \"ploughing of the wicked is sin.\" When it is done with a bad motive, out of pride. Hebrew, \"the haughtiness of the eyes, and the enlarging of the heart, are the labour (\"tillage,\" Montanus; \"thought,\" Pagnin) of the wicked; yea, sin.\" (Haydock) — Those things are their employment, and their sin. (Calmet) — Septuagint and Vulgate may also mean, \"sin is the lamp and exultation of the wicked.\"", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Sluggard. Hebrew, \"hasty man,\" as the slothful is ironically styled. He would see his desires accomplished without labouring; and will never stick to work. This levity is most injurious to his advancement.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Death. Their injustice shall be punished.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Strange. Unknown, impure way, Leviticus x. 1., and Deuteronomy xvii. 15.", attribution: "Calmet" }
    ] },
    { verse: 9, notes: [
      { text: "Top, (domatis) as the roofs in Palestine were flat. (St. Jerome, ad Sun.) — Any inconvenience had better be endured, than to live with the quarrelsome.", attribution: "Menochius" }
    ] },
    { verse: 10, notes: [
      { text: "Neighbour. Symmachus, \"he has no idea of friendship.\" Septuagint, \"he shall not be treated with mercy by any man.\"", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Knowledge. These are the effects of chastisements and good company.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Evil. He tries every expedient to save him. — That. Septuagint, \"he despises.\" Symmachus, \"throws down.\"", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Bosom. In private. (Calmet) — They put all valuable things in the bosom.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "To do judgment. Or to see it done, while the wicked depend only on the corruption of their judges.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Giants, in hell, chap xv. 11., Job xxvi. 5., and Ezechiel xxii. 21.", attribution: "Haydock" }
    ] },
    { verse: 17, notes: [
      { text: "Rich. Economy is constantly recommended. (Calmet) — Those who squandered away their goods, were fined by the Areopagites.", attribution: "Athen. iv. 19." }
    ] },
    { verse: 18, notes: [
      { text: "Righteous. Many are deterred from wickedness by the punishment of malefactors, whose injuries are frequently irreparable. God abandoned Pharao and Aman to save his people. He treated them as victims of wrath, Isaias xliii. 3.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Treasure of provisions. Temporal blessings were promised as a figure of more lasting ones, which are set before Christians.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Thereof. Nothing can resist, Matthew xii. 29., and Ecclesiastes ix. 16.", attribution: "Calmet" }
    ] },
    { verse: 23, notes: [
      { text: "Mouth, from eating too much.", attribution: "Lyranus" }
    ] },
    { verse: 24, notes: [
      { text: "Ignorant. Hebrew, \"a scoffer.\" Septuagint, \"pestilent.\" (Haydock) — Such a one is always actuated by pride, when he attempts to turn good advice and religion to ridicule.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "At all. Hence his desires of riches and wisdom prove fruitless, chap. xiii. 4.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Wickedness. Hebrew, \"with an evil thought.\" (Montanus) Ecclesiasticus xxxiv. 24.", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Obedient. Attentive, faithful witness, shall speak with triumph, or he who obeys the law, shall gain the victory over the devil, &c.", attribution: "Philippians ii. 8." }
    ] },
    { verse: 29, notes: [
      { text: "Face. Never blushing, or yielding to good advice.", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "Battle. It was kept for no other purpose by the eastern nations, who used oxen to till the land; asses and camels to carry burdens, Job xxxix. 18., and Psalm xix. 8., and xxxii. 17.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
